import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleChangeValue, handlePost } from '../../../../utils/AxiosUtil';
import * as util from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwarePositiveAmountField from '../../../common/inputfields/ErrorAwarePositiveAmount';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';

class TaxTransition extends Component {
    // fields = ["toTaxTypeId", "fromTaxTypeId"];

    state = {
        selectedFromTaxType: {},
        selectedToTaxType: {},
        amount: '',
        comment: '',
        date: new Date(),
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            selectedFromTaxType: {},
            selectedToTaxType: {},
            amount: '',
            comment: '',
            date: new Date(),
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/taxtransition';
        const requestObject = {
            "fromTaxTypeId": this.state.selectedFromTaxType.value,
            "toTaxTypeId": this.state.selectedToTaxType.value,
            "amount": util.toNumber(this.state.amount),
            "date": util.toDateFormat(this.state.date),
            "comment": this.state.comment,
        };
        handlePost(path, requestObject, this);
    };

    promiseTaxTypeOptions = async () => {
        const response = await axios.get('/api/taxtypes')
        const renamedCustomers = [];
        response.data.map((taxtype) =>
            renamedCustomers.push({
                label: taxtype.publicId ? taxtype.publicId + '-' + taxtype.name : taxtype.name,
                value: taxtype.privateId,
            }));
        return renamedCustomers;
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseTaxTypeOptions}
                            onChange={(e, v) => handleChangeValue(v, "selectedFromTaxType", this)}
                            label={'Honnan Adónem'}
                            value={this.state.selectedFromTaxType}
                            errors={this.state.errors}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseTaxTypeOptions}
                            onChange={(e, v) => handleChangeValue(v, "selectedToTaxType", this)}
                            label={'Hova Adónem'}
                            value={this.state.selectedToTaxType}
                            errors={this.state.errors}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwarePositiveAmountField
                            required
                            name="amount"
                            label="Összeg"
                            value={this.state.amount}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="date"
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={v => handleChangeValue(v, "date", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(TaxTransition);
